import styled from "styled-components";
import React, { FC, useEffect, useState } from "react";
import Wordle from "./Wordle";
import Tooltip from "./Tooltip";
import useWordle from "../hooks/useWordle";

const Game: FC = () => {
  const [solution, setSolution] = useState<string>("");
  const wordleHook = useWordle(solution);
  const { turn } = wordleHook;
  const [hint, setHint] = useState<string>();

  // GESTION DES ESPACES ET - ET ' DANS LE NOM DES PAYS
  //N-Su t'an

  // Initialisation du jeu
  useEffect(() => {
    const fetchData = async () => {
      try {
        // const response = await fetch('/data/db.json');
        const jsonData = require("./../data/db.json");
        const randomSolution =
          jsonData[Math.floor(Math.random() * jsonData.length)];

        const keys = Object.keys(randomSolution);
        const randomKey = keys[Math.floor(Math.random() * keys.length)];
        const hintKey = randomSolution[randomKey];

        setSolution(hintKey);
        setHint(randomKey);

        console.log("Clés existantes", keys);
        console.log("KEY officiel :", randomKey);
        console.log("MOT A DEVINER", hintKey);
      } catch (error) {
        console.error("Erreur jsonData", error);
      }
    };

    fetchData();
  }, []);

  return (
    <Container className="game-container">
      <div className="header">
        <p>Trouve le nom d'un pays ou d'une capitale.</p>
        <div className="material-container">
          {turn > 4 ? (
            <Tooltip
              children={
                <span className="material-icons" style={{ color: "#d9a234" }}>
                  lightbulb_circle
                </span>
              }
              placement={"left"}
              text={
                hint === "capital"
                  ? "Tu cherches une capitale."
                  : "Tu cherches un pays."
              }
            />
          ) : (
            <Tooltip
              children={
                <span className="material-icons" style={{ color: "#cfe3ec" }}>
                  lightbulb_circle
                </span>
              }
              placement={"left"}
              text={"Indice après 5 tentatives"}
            />
          )}

          <Tooltip
            children={<span className="material-icons">help</span>}
            placement="bottom"
            text={
              <div>
                <p>Devinez votre destination en six tentatives maximum.</p>
                <p>
                  Les lettres bien placées apparaissent en bleu foncé, les
                  lettres présentes mais mal placées en bleu clair.
                </p>
                <p>Utilise ta logique pour deviner ta destination !</p>
              </div>
            }
          />
        </div>
      </div>

      {solution && <Wordle solution={solution} {...wordleHook} />}
    </Container>
  );
};

const Container = styled.div`
  height: 600px;
  width: 800px;
  background-color: #f8f1e1;
  background-image:
    radial-gradient(circle at 0 0, rgba(11, 61, 85, 0.03) 1px, transparent 1px);
  background-size: 14px 14px;
  border: 2px dashed #d9a234;
  border-radius: 30px;
  box-shadow: 0 20px 45px rgba(4, 32, 46, 0.45);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  > .header {
    display: flex;
    width: 80%;
    justify-content: center;
    padding: 0 0 20px 0;
    font-size: 1.25rem;
    color: #0b3d55;

    > p {
      margin: 8px;
      font-weight: 500;
    }

    > .material-container {
      position: absolute;
      margin: 20px;
      top: 0;
      right: 0;

      > Tooltip,
      .material-icons {
        position: relative;
        z-index: 100;
        font-size: 1.75rem;
        color: #0b3d55;
      }
    }
  }
`;

export default Game;
